/**
 * Inject <link rel="preconnect"> for unique image-host origins found on modules.
 * Idempotent: skips origins already present in document.head.
 */
export function preconnectModuleImageOrigins(modules = []) {
  if (typeof document === "undefined" || !Array.isArray(modules)) {
    return
  }

  const origins = [
    ...new Set(
      modules
        .map((module) => module?.img_url || module?.imgUrl || "")
        .filter(Boolean)
        .map((url) => {
          try {
            return new URL(String(url).trim()).origin
          } catch {
            return null
          }
        })
        .filter(Boolean)
    ),
  ]

  origins.forEach((origin) => {
    if (document.querySelector(`link[rel="preconnect"][href="${origin}"]`)) {
      return
    }

    const link = document.createElement("link")
    link.rel = "preconnect"
    link.href = origin
    document.head.appendChild(link)
  })
}
